import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * TableSearch — مربع بحث موحّد فوق جداول البيانات.
 *
 * يعمل بنمطين:
 *  - بحث محلي: الصفحة تحمّل كل الصفوف ويُفلتر في المتصفح (مع عدّاد النتائج)
 *  - بحث على الخادم: العبارة تُرسل مع الطلب (مرّر resultCount فقط)
 *
 * @param {object} props
 * @param {string} props.value
 * @param {(v: string) => void} props.onChange
 * @param {string} [props.placeholder]
 * @param {number} [props.resultCount] عدد النتائج بعد الفلترة
 * @param {number} [props.totalCount]  إجمالي الصفوف قبل الفلترة
 * @param {string} [props.hint] عبارة توضيحية تظهر تحت الحقل
 * @param {string} [props.className]
 */
export default function TableSearch({
  value,
  onChange,
  placeholder = 'ابحث في الجدول...',
  resultCount,
  totalCount,
  hint,
  className = '',
}) {
  const hasQuery = Boolean(value && String(value).trim());
  const showCount = hasQuery && typeof resultCount === 'number';

  return (
    <div className={`w-full ${className}`}>
      <div className="relative">
        <Search className="pointer-events-none absolute top-1/2 -translate-y-1/2 right-3 rtl:right-3 ltr:left-3 ltr:right-auto h-4 w-4 text-gray-400 dark:text-gray-500" />
        {/* type=text لا search: المتصفح يرسم زر مسح خاصاً به مع search
            فيظهر زرّان متجاوران بجانب زر المسح أدناه */}
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          className="w-full rounded-lg border border-gray-300 bg-white py-2.5 pr-10 pl-9 text-gray-900 placeholder:text-gray-400 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder:text-gray-500"
        />
        {hasQuery && (
          <button
            type="button"
            onClick={() => onChange('')}
            title="مسح البحث"
            aria-label="مسح البحث"
            className="absolute top-1/2 -translate-y-1/2 left-2 rtl:left-2 ltr:right-2 ltr:left-auto rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-600 dark:hover:text-gray-200"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      {(showCount || hint) && (
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          {showCount && (
            resultCount === 0
              ? 'لا توجد نتائج مطابقة'
              : `${resultCount}${typeof totalCount === 'number' ? ` من ${totalCount}` : ''} نتيجة`
          )}
          {showCount && hint ? ' — ' : ''}
          {hint}
        </p>
      )}
    </div>
  );
}
